import React, { useEffect, useMemo, useRef, useState } from 'react';

import moment, { Moment } from 'moment';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import DateRangePicker from './DateRangePicker';
import { IoCalendarOutline } from 'react-icons/io5';
import classNames from 'classnames';
import { RootState } from 'app/store';
import { LanguageSelectType } from '@slice/user.slice';
import { convertTime } from '@pages/OrganizedSales/CreateOrders/utilOrder';
import { updateResetDateTime } from '@slice/select.slice';
type RangeValue = [Moment | null, Moment | null] | null;

enum CheckDateSBE {
  SAME_START = 'SAME_STAR',
  SAME_END = 'SAME_END',
  BEFORE_START = 'BEFORE_START',
  END_END = 'END_END',
  IN_RANGE = 'IN_RANGE'
}
export interface IRangeDateJsProps {
  onSelectDateChange: (date: any, stringDate?: string[] | undefined) => any;
  limitTimeRange?: number;
  isForceHidden?: boolean;
  isForceReset?: boolean;
  widthBox?: number;
  widthAuto?: boolean;
  limitPrevDates?: number; // thời gian tối đa lùi về trước
  checkType?: any;
  disabled?: boolean; // thêm prop disabled
}

const RangeDateJs = (props: IRangeDateJsProps) => {
  const { t } = useTranslation();
  const refTime = useRef<any>();
  const dispatch = useDispatch();
  const { disabled } = props; // destructuring disabled
  const resetTime = useSelector((state: RootState) => state.select.resetTime);

  const [rangeVi, setRangeVi] = useState<any>();
  const [rangeEn, setRangeEn] = useState<any>();
  useMemo(() => {
    if (props.checkType === 'theodon' || props.checkType === 'kythuat') {
      setRangeEn({
        Today: [moment().startOf('day'), moment().endOf('day')],
        Yesterday: [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
        'This month': [moment().startOf('month'), moment().endOf('day')],
        'In 2 days': [moment().add(-1, 'days').startOf('day'), moment().endOf('day')],
        'In 3 days': [moment().add(-2, 'days').startOf('day'), moment().endOf('day')],
        'In 7 days': [moment().add(-6, 'days').startOf('day'), moment().endOf('day')],
        '14 days latest': [moment().add(-13, 'days').startOf('day'), moment().endOf('day')],
        // '15 days latest': [moment().add(-14, 'days').startOf('day'), moment().endOf('day')]
        '31 days latest': [moment().add(-30, 'days').startOf('day'), moment().endOf('day')]
      });
    } else if (props.checkType === 'sim') {
      setRangeEn({
        Today: [moment().startOf('day'), moment().endOf('day')],
        Yesterday: [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
        'This month': [moment().startOf('month'), moment().endOf('day')],
        'In 2 days': [moment().add(-1, 'days').startOf('day'), moment().endOf('day')],
        'In 3 days': [moment().add(-2, 'days').startOf('day'), moment().endOf('day')],
        'In 7 days': [moment().add(-6, 'days').startOf('day'), moment().endOf('day')],
        '14 days latest': [moment().add(-13, 'days').startOf('day'), moment().endOf('day')],
        '31 days latest': [moment().add(-30, 'days').startOf('day'), moment().endOf('day')],
        // '3 month': [moment().add(-93, 'days').startOf('day'), moment().endOf('day')],
        // '6 month': [moment().add(-183, 'days').startOf('day'), moment().endOf('day')],
        '3 month': [moment().subtract(3, 'months').startOf('day'), moment().endOf('day')],
        '6 month': [moment().subtract(6, 'months').startOf('day'), moment().endOf('day')]
      });
    } else if (props.checkType === 'congno' || props.checkType === 'doanhthu') {
      setRangeEn({
        Today: [moment().startOf('day'), moment().endOf('day')],
        Yesterday: [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
        'This month': [moment().startOf('month'), moment().endOf('day')],
        'In 3 days': [moment().add(-2, 'days').startOf('day'), moment().endOf('day')],
        'In 7 days': [moment().add(-6, 'days').startOf('day'), moment().endOf('day')],
        '14 days latest': [moment().add(-13, 'days').startOf('day'), moment().endOf('day')],
        '31 days latest': [moment().add(-30, 'days').startOf('day'), moment().endOf('day')],
        // '3 month': [moment().add(-93, 'days').startOf('day'), moment().endOf('day')],
        // '6 month': [moment().add(-183, 'days').startOf('day'), moment().endOf('day')],
        // '1 year': [moment().add(-367, 'days').startOf('day'), moment().endOf('day')]
        '3 month': [moment().subtract(3, 'months').startOf('day'), moment().endOf('day')],
        '6 month': [moment().subtract(6, 'months').startOf('day'), moment().endOf('day')],
        '1 year': [moment().subtract(1, 'year').startOf('day'), moment().endOf('day')]
      });
    } else {
      setRangeEn({
        Today: [moment().startOf('day'), moment().endOf('day')],
        Yesterday: [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
        'This month': [moment().startOf('month'), moment().endOf('day')],
        'In 2 days': [moment().add(-1, 'days').startOf('day'), moment().endOf('day')],
        'In 3 days': [moment().add(-2, 'days').startOf('day'), moment().endOf('day')],
        'In 7 days': [moment().add(-6, 'days').startOf('day'), moment().endOf('day')],
        '14 days latest': [moment().add(-13, 'days').startOf('day'), moment().endOf('day')],
        '31 days latest': [moment().add(-30, 'days').startOf('day'), moment().endOf('day')]
      });
    }
  }, [props.checkType]);
  useMemo(() => {
    if (props.checkType === 'theodon' || props.checkType === 'kythuat') {
      setRangeVi({
        'Hôm nay': [moment().startOf('day'), moment().endOf('day')],
        'Hôm qua': [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
        'Tháng này': [moment().startOf('month'), moment().endOf('day')],
        '2 ngày': [moment().add(-1, 'days').startOf('day'), moment().endOf('day')],
        '3 ngày': [moment().add(-2, 'days').startOf('day'), moment().endOf('day')],
        '7 ngày': [moment().add(-6, 'days').startOf('day'), moment().endOf('day')],
        '14 ngày': [moment().add(-13, 'days').startOf('day'), moment().endOf('day')],
        // '15 ngày': [moment().add(-14, 'days').startOf('day'), moment().endOf('day')],
        '31 ngày': [moment().add(-30, 'days').startOf('day'), moment().endOf('day')]
      });
    } else if (props.checkType === 'sim') {
      setRangeVi({
        'Hôm nay': [moment().startOf('day'), moment().endOf('day')],
        'Hôm qua': [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
        'Tháng này': [moment().startOf('month'), moment().endOf('day')],
        '2 ngày': [moment().add(-1, 'days').startOf('day'), moment().endOf('day')],
        '3 ngày': [moment().add(-2, 'days').startOf('day'), moment().endOf('day')],
        '7 ngày': [moment().add(-6, 'days').startOf('day'), moment().endOf('day')],
        '14 ngày': [moment().add(-13, 'days').startOf('day'), moment().endOf('day')],
        '31 ngày': [moment().add(-30, 'days').startOf('day'), moment().endOf('day')],
        '3 tháng': [moment().subtract(3, 'months').startOf('day'), moment().endOf('day')],
        '6 tháng': [moment().subtract(6, 'months').startOf('day'), moment().endOf('day')]
        // '3 tháng': [moment().add(-93, 'days').startOf('day'), moment().endOf('day')],
        // '6 tháng': [moment().add(-183, 'days').startOf('day'), moment().endOf('day')]
      });
    } else if (props.checkType === 'congno' || props.checkType === 'doanhthu') {
      // doanhthu: BC doanh thu V3, chọn nhanh tới 1 năm như công nợ
      setRangeVi({
        'Hôm nay': [moment().startOf('day'), moment().endOf('day')],
        'Hôm qua': [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
        'Tháng này': [moment().startOf('month'), moment().endOf('day')],
        '3 ngày': [moment().add(-2, 'days').startOf('day'), moment().endOf('day')],
        '7 ngày': [moment().add(-6, 'days').startOf('day'), moment().endOf('day')],
        '14 ngày': [moment().add(-13, 'days').startOf('day'), moment().endOf('day')],
        '31 ngày': [moment().add(-30, 'days').startOf('day'), moment().endOf('day')],
        '3 tháng': [moment().subtract(3, 'months').startOf('day'), moment().endOf('day')],
        '6 tháng': [moment().subtract(6, 'months').startOf('day'), moment().endOf('day')],
        '1 năm': [moment().subtract(1, 'year').startOf('day'), moment().endOf('day')]
        // '3 tháng': [moment().add(-93, 'days').startOf('day'), moment().endOf('day')],
        // '6 tháng': [moment().add(-183, 'days').startOf('day'), moment().endOf('day')],
        // '1 năm': [moment().add(-367, 'days').startOf('day'), moment().endOf('day')]
      });
    } else {
      setRangeVi({
        'Hôm nay': [moment().startOf('day'), moment().endOf('day')],
        'Hôm qua': [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
        'Tháng này': [moment().startOf('month'), moment().endOf('day')],
        '2 ngày': [moment().add(-1, 'days').startOf('day'), moment().endOf('day')],
        '3 ngày': [moment().add(-2, 'days').startOf('day'), moment().endOf('day')],
        '7 ngày': [moment().add(-6, 'days').startOf('day'), moment().endOf('day')],
        '14 ngày': [moment().add(-13, 'days').startOf('day'), moment().endOf('day')],
        '31 ngày': [moment().add(-30, 'days').startOf('day'), moment().endOf('day')]
      });
    }
  }, [props.checkType]);

  const refSelectMemory = useRef<any>(undefined);

  // có thể lưu lại cho lần mở khác nếu ng dùng thích dùng 1 hoặc 2 lịch luôn npm i bootstrap-daterangepicker
  // const preSelectDate31 = useSelector((state: RootState) => state.select.preSelectDate31);
  const preSelectDate7 = useSelector((state: RootState) => state.select.preSelectDate7);

  const timeSelected = useSelector((state: RootState) => state.select.selectedTime);
  // const limitDateSelect = useSelector((state: RootState) => state.select.limitDateSelect);
  const language = useSelector((state: RootState) => state.user.language);
  const [dates, setDates] = useState<any>(() => {
    return [
      moment(moment().startOf('day').toISOString(true), 'YYYY-MM-DDTHH:mm:ss'),
      moment(moment().endOf('day').toISOString(true), 'YYYY-MM-DDTHH:mm:ss')
    ];
  });

  // const [showDr, setShowDr] = useState<boolean>(false);
  const [timeLimit, setTimeLimit] = useState<number>(props.limitTimeRange ? props.limitTimeRange : 31);
  const [openTutorial, setOpenTutorial] = useState<boolean>(false);

  const useRangeLang = useMemo(() => {
    if (language === LanguageSelectType.ENGLISH) return rangeEn;
    return rangeVi;
  }, [language, rangeEn, rangeVi]);

  const daysOfWeekLang = useMemo(() => {
    return [
      t('RangeDate.DaysOfWeek.CN'),
      t('RangeDate.DaysOfWeek.T2'),
      t('RangeDate.DaysOfWeek.T3'),
      t('RangeDate.DaysOfWeek.T4'),
      t('RangeDate.DaysOfWeek.T5'),
      t('RangeDate.DaysOfWeek.T6'),
      t('RangeDate.DaysOfWeek.T7')
    ];
  }, [t]);

  const monthNamesLang = useMemo(() => {
    return [
      t('RangeDate.MonthNames.Month1'),
      t('RangeDate.MonthNames.Month2'),
      t('RangeDate.MonthNames.Month3'),
      t('RangeDate.MonthNames.Month4'),
      t('RangeDate.MonthNames.Month5'),
      t('RangeDate.MonthNames.Month6'),
      t('RangeDate.MonthNames.Month7'),
      t('RangeDate.MonthNames.Month8'),
      t('RangeDate.MonthNames.Month9'),
      t('RangeDate.MonthNames.Month10'),
      t('RangeDate.MonthNames.Month11'),
      t('RangeDate.MonthNames.Month12')
    ];
  }, [t]);

  /**
   *
   * Xử lý click vào icon mở lịch
   */
  const handleClickIcon = () => {
    const range_pickerjs = document.querySelector('.range_pickerjs') as HTMLInputElement | null;
    range_pickerjs! && range_pickerjs.focus();
  };
  /**
   *Hàm xử lý lịch huyền thoại
   * @param start
   *
   * @param end
   * @param checkDate
   * @returns xử lý ngày chọn
   * ***
   * chỉ chạy khi nhấn nút áp dụng hoặc nhấn bên ngoài và có thay đổi giá trị của ngày trong picker date
   */

  const handleCallback = (start: any, end: any, checkDate: any, isLeftMonth?: any, sameMonth?: any) => {
    // if (checkDate == '0') {
    //   /**
    //    * khi vào trường hợp này thì start xem như ngày mới chọn end xem như là check chọn lịch phải hay trái, checkDate == '0' là điều kiện để vào đây
    //    * startDate, endDate chỉ có khi vào trường hợp này
    //    */
    //   console.log('không có check date - đang hiện 1 lịch', start, end, checkDate, startDate, endDate);

    //   const beginTimeOld: Moment | null = dates && dates[0];
    //   const EndTimeOld: Moment | null = dates && dates[1];
    //   const beginTimeNew: Moment | null = startDate;
    //   const endTimeNew: Moment | null = endDate;
    //   const checkDateCB: Moment | null = start;
    //   console.log('show pam', beginTimeOld, EndTimeOld, beginTimeNew, endTimeNew, checkDateCB);
    //   openTutorial && setOpenTutorial(false); // đóng bảng hướng dẫn nếu mở
    //   let beginDayLast = beginTimeNew?.format('MM/DD/YYYY');
    //   let endDaylast = endTimeNew?.format('MM/DD/YYYY');

    //   // console.log('run contined');
    //   const dateString = ['', ''];
    //   const lastBeginHour = beginTimeNew ? beginTimeNew?.format('HH:mm') : '00:00';
    //   const lastEndHour = endTimeNew ? endTimeNew?.format('HH:mm') : '23:59';
    //   const lastBeginTime = lastBeginHour + ' ' + beginDayLast;
    //   const lastEndTime = lastEndHour + ' ' + endDaylast;

    //   // thời gian mặc định là 0000-2359
    //   props.onSelectDateChange([lastBeginTime, lastEndTime], dateString);
    //   refTime.current.setStartDate(moment(lastBeginTime, 'HH:mm MM/DD/YYYY'));
    //   refTime.current.setEndDate(moment(lastEndTime, 'HH:mm MM/DD/YYYY'));

    //   return 0;
    // }
    const beginTimeOld: Moment | null = dates && dates[0];
    const EndTimeOld: Moment | null = dates && dates[1];
    const beginTimeNew: Moment | null = start;
    const endTimeNew: Moment | null = end;
    const checkDateCB: Moment | null = checkDate;
    // cắt thời gian ra để đẽ xử lý
    // const beginTimeSl = beginTimeNew._i && beginTimeNew._i.split(' ');
    // const endTimeSl = endTimeNew._i && endTimeNew._i.split(' ');
    // console.log(
    //   'select picker onchange check luôn',
    //   // beginTimeNew?.format('DD/MM/YYYY'),
    //   // endTimeNew?.format('DD/MM/YYYY'),
    //   // checkDateCB?.format('DD/MM/YYYY'),
    //   // beginTimeOld?.format('DD/MM/YYYY'),
    //   // EndTimeOld?.format('DD/MM/YYYY'),
    //   limitDateSelect,
    //   timeLimit
    //   // refTime.current
    // );

    openTutorial && setOpenTutorial(false); // đóng bảng hướng dẫn nếu mở
    let beginDayLast = beginTimeNew?.format('MM/DD/YYYY');
    let endDaylast = endTimeNew?.format('MM/DD/YYYY');

    if (sameMonth && sameMonth == '0' && timeLimit >= 5) {
      if (isLeftMonth) {
        // chọn bên trái kiểm tra ngày chọn và ngày kết thúc

        const rangeDiffDays = moment.duration(endTimeNew!.diff(checkDateCB)).asDays();
        // console.log('BStart', rangeDiffDays);
        // / có thể xử lý thêm nếu chọn luôn bên này mà check < 0
        beginDayLast = checkDateCB!.format('MM/DD/YYYY');

        if (rangeDiffDays < 0) {
          let rangeDiffDaysPre = moment.duration(endTimeNew!.diff(beginTimeNew)).asDays();

          console.log('chọn lố ngược', rangeDiffDaysPre);

          if (rangeDiffDaysPre >= timeLimit) {
            rangeDiffDaysPre = timeLimit;
            // console.log('next pass');
          }
          if (rangeDiffDaysPre < 1) {
            rangeDiffDaysPre = 1;
          }
          beginDayLast = checkDateCB?.format('MM/DD/YYYY');
          endDaylast = checkDateCB!.add(rangeDiffDaysPre - 1, 'days').format('MM/DD/YYYY');
        } else if (rangeDiffDays >= timeLimit) {
          endDaylast = checkDateCB!.add(timeLimit - 1, 'days').format('MM/DD/YYYY');
        }
      } else {
        // chọn bên phải

        const rangeDiffDays = moment.duration(checkDateCB!.diff(beginTimeNew)).asDays();
        console.log('EEnd', rangeDiffDays);
        // có thể xử lý thêm nếu chọn luôn bên này mà check < 0
        endDaylast = checkDateCB!.format('MM/DD/YYYY');
        if (rangeDiffDays < 0) {
          let rangeDiffDaysPre = moment.duration(endTimeNew!.diff(beginTimeNew)).asDays();

          console.log('chọn lố ngược', rangeDiffDaysPre);
          if (rangeDiffDaysPre >= timeLimit) {
            rangeDiffDaysPre = timeLimit;
            // console.log('next pass');
          }
          if (rangeDiffDaysPre < 1) {
            rangeDiffDaysPre = 1;
          }
          endDaylast = checkDateCB!.format('MM/DD/YYYY');
          beginDayLast = checkDateCB?.subtract(rangeDiffDaysPre - 1, 'days').format('MM/DD/YYYY');
        } else if (rangeDiffDays >= timeLimit) {
          beginDayLast = checkDateCB!.subtract(timeLimit - 1, 'days').format('MM/DD/YYYY');
        }
      }
    } else {
      /**
       *
       * @param startDate Moment
       *
       * @param endDate Moment
       * @param dateCheck Moment
       * @returns CheckDateSBE enum
       */

      const checkDateSelect = (startDate: Moment | null, endDate: Moment | null, dateCheck: Moment | null) => {
        if (dateCheck?.isSame(startDate, 'day')) {
          return CheckDateSBE.SAME_START;
        } else if (dateCheck?.isSame(endDate, 'day')) {
          return CheckDateSBE.SAME_END;
        } else if (dateCheck?.isBetween(startDate, endDate, 'days')) {
          return CheckDateSBE.IN_RANGE;
        } else if (checkDate.isBefore(startDate, 'day')) {
          return CheckDateSBE.BEFORE_START;
        } else {
          return CheckDateSBE.END_END;
        }
      };

      // nếu chọn ngày trước là giờ là 23:59 thì nghĩa là đúng bằng range limit (số chẵn 1 2 31 .. )
      if (beginTimeOld && EndTimeOld && beginTimeNew && endTimeNew && checkDateCB) {
        // trường hợp đầu tiên chọn ngày bắt đầu hoặc kết thúc đúng vào điểm mút đầu hoăc cuối

        const rltCheckSBE: CheckDateSBE | null = checkDateCB && checkDateSelect(beginTimeNew, endTimeNew, checkDateCB);
        console.log('rlt', rltCheckSBE);

        if (rltCheckSBE) {
          switch (rltCheckSBE) {
            case CheckDateSBE.SAME_START: {
              refSelectMemory.current = undefined;
              endDaylast = beginDayLast;
              break;
            }

            case CheckDateSBE.SAME_END: {
              refSelectMemory.current = undefined;
              beginDayLast = endDaylast;
              break;
            }
            case CheckDateSBE.BEFORE_START: {
              refSelectMemory.current = 'setEnd';
              const rangeDiffDays = moment.duration(endTimeNew.diff(checkDateCB)).asDays();
              // console.log('BStart', rangeDiffDays);
              beginDayLast = checkDateCB.format('MM/DD/YYYY');
              if (rangeDiffDays >= timeLimit) {
                endDaylast = checkDateCB!.add(timeLimit - 1, 'days').format('MM/DD/YYYY');
              }
              break;
            }
            case CheckDateSBE.END_END: {
              refSelectMemory.current = 'setStart';
              const rangeDiffDays = moment.duration(checkDateCB!.diff(beginTimeNew)).asDays();
              // console.log('EEnd', rangeDiffDays);
              endDaylast = checkDateCB.format('MM/DD/YYYY');
              if (rangeDiffDays >= timeLimit) {
                beginDayLast = checkDateCB!.subtract(timeLimit - 1, 'days').format('MM/DD/YYYY');
              }
              break;
            }
            case CheckDateSBE.IN_RANGE: {
              if (refSelectMemory.current != 'setMid') {
                const durationStart = moment.duration(checkDateCB!.diff(beginTimeNew)).asMinutes() + 1439;
                const durationEnd = moment.duration(endTimeNew!.diff(checkDateCB)).asMinutes();
                // chỗ so sánh này giờ bắt đầu bị mất đi 8 tiếng
                console.log('xử lý chọn giờ bên trong', durationStart, durationEnd, refSelectMemory.current);
                if (durationStart < durationEnd) {
                  // thu gọn ngày bắt đầu lại lấy ngày kết thúc làm chuẩn
                  refSelectMemory.current = 'setEnd';
                  beginDayLast = checkDateCB.format('MM/DD/YYYY');
                } else if (durationStart > durationEnd) {
                  // thu gọn ngày kết thúc lại lấy ngày bắt đầu làm chuẩn
                  endDaylast = checkDateCB.format('MM/DD/YYYY');
                  refSelectMemory.current = 'setStart';
                } else {
                  console.log('check mid mer', refSelectMemory.current);
                  // tạm thời sẽ lấy ngày kết thúc làm chuẩn thu gọn ngày bắt đầu lại
                  // beginDayLast = checkDateCB.format('MM/DD/YYYY');
                  // xử lý luôn bên trong  k cần set cứng cái nào cả
                  if (refSelectMemory.current == 'setEnd') {
                    beginDayLast = checkDateCB.format('MM/DD/YYYY');
                    // refSelectMemory.current = undefined;
                    break;
                  }
                  if (refSelectMemory.current == 'setStart') {
                    endDaylast = checkDateCB.format('MM/DD/YYYY');
                    // refSelectMemory.current = undefined;
                    break;
                  }
                }
              }
              break;
            }
            default:
              break;
          }
        }
      }

      if (checkDateCB == null) {
        const rangeDiffDays = moment.duration(endTimeNew?.diff(beginTimeNew)).asDays();
        if (rangeDiffDays < 0) {
          // Toast(t('DatePicker.NoValidDateTime'), ToastType.ERROR);
          // console.log('xử lý thời gian chọn sai ngược', rangeDiffDays);
          refTime.current.setStartDate(moment(beginTimeOld, 'HH:mm MM/DD/YYYY'));
          refTime.current.setEndDate(moment(EndTimeOld, 'HH:mm MM/DD/YYYY'));
          return;
        }
        if (rangeDiffDays >= timeLimit) {
          // console.log('xử lý thời gian chọn quá giới hạn one', rangeDiffDays);
          refTime.current.setStartDate(moment(beginTimeOld, 'HH:mm MM/DD/YYYY'));
          refTime.current.setEndDate(moment(EndTimeOld, 'HH:mm MM/DD/YYYY'));
          return;
        }
      }
    }

    const dateString = ['', ''];
    const lastBeginHour = beginTimeNew ? beginTimeNew?.format('HH:mm') : '00:00';
    const lastEndHour = endTimeNew ? endTimeNew?.format('HH:mm') : '23:59';
    const lastBeginTime = lastBeginHour + ' ' + beginDayLast;
    const lastEndTime = lastEndHour + ' ' + endDaylast;

    // thời gian mặc định là 0000-2359
    props.onSelectDateChange([lastBeginTime, lastEndTime], dateString);
    refTime.current.setStartDate(moment(lastBeginTime, 'HH:mm MM/DD/YYYY'));
    refTime.current.setEndDate(moment(lastEndTime, 'HH:mm MM/DD/YYYY'));
  };

  useEffect(() => {
    // console.log(
    //   'default',
    //   props.limitTimeRange,
    //   limitDateSelect,
    //   timeLimit,
    //   limitDateSelect != -1 ? limitDateSelect : props.limitTimeRange ? props.limitTimeRange : 31
    // );
    // xử lý đặc biệt khi đổi kiểu select time 2 hoặc 31 trong cùng 1 page chức năng
    const limitDetect = props.limitTimeRange ? props.limitTimeRange : 31;

    // có hay k cũng set limit time range
    setTimeLimit(limitDetect);

    // xử lý phần ranges chọn nhanh
    const ranges = document.querySelector('.ranges') as HTMLElement | null;
    if (ranges) {
      const listRanges = ranges.querySelector('ul') as HTMLElement | null;
      console.log('ranges', listRanges, limitDetect);
      if (listRanges) {
        // có listRanges eidt nó
        if (limitDetect == 1) {
          for (let i = 0; i < listRanges.children.length; i++) {
            // console.log('index 1', i, listRanges.children[i]);
            if (i > 1) {
              const elm: any = listRanges.children[i];
              elm.style.display = 'none';
            }
          }
        }
        if (limitDetect == 2 || limitDetect == 3) {
          for (let i = 0; i < listRanges.children.length; i++) {
            // console.log('index 2', i, listRanges.children[i]);
            if (!(i < 2 || i == 3)) {
              const elm: any = listRanges.children[i];
              elm.style.display = 'none';
            }
          }
        }
        if (limitDetect == 5) {
          for (let i = 0; i < listRanges.children.length; i++) {
            // console.log('index 5', i, listRanges.children[i]);
            if (!(i < 2 || i == 3 || i == 4)) {
              const elm: any = listRanges.children[i];
              elm.style.display = 'none';
            }
          }
        }
        if (limitDetect == 7) {
          for (let i = 0; i < listRanges.children.length; i++) {
            if (!(i < 2 || i == 3 || i == 4 || i == 5)) {
              const elm: any = listRanges.children[i];
              elm.style.display = 'none';
            }
          }
        }
        // if (limitDetect == 31) {
        //   for (let i = 0; i < listRanges.children.length; i++) {
        //     // console.log('index 5', i, listRanges.children[i]);
        //     const elm: any = listRanges.children[i];
        //     elm.style.display = 'block';
        //   }
        // }

        if (limitDetect == 31) {
          for (let i = 0; i < listRanges.children.length; i++) {
            if (i > 7) {
              // listRanges.children[i].style.display = 'none';
              const elm: any = listRanges.children[i];
              elm.style.display = 'none';
            } else {
              // listRanges.children[i].style.display = 'block';
              const elm: any = listRanges.children[i];
              elm.style.display = 'block';
            }
          }
        }

        if (limitDetect == 94) {
          for (let i = 0; i < listRanges.children.length; i++) {
            // listRanges.children[i].style.display = 'block';
            const elm: any = listRanges.children[i];
            elm.style.display = 'block';
          }
        }

        if (limitDetect == 184) {
          for (let i = 0; i < listRanges.children.length; i++) {
            // listRanges.children[i].style.display = 'block';
            const elm: any = listRanges.children[i];
            elm.style.display = 'block';
          }
        }

        if (limitDetect == 366) {
          for (let i = 0; i < listRanges.children.length; i++) {
            // listRanges.children[i].style.display = 'block';
            const elm: any = listRanges.children[i];
            elm.style.display = 'block';
          }
        }
      }
      // k có list range có thể thêm ...
    }
    // xử lý phần label limit
    const drpButtons = document.querySelector('.drp-buttons') as HTMLElement | null;
    if (drpButtons) {
      const labelLimited = drpButtons.querySelector('.label-limited') as HTMLElement | null;
      if (labelLimited) {
        const checkExitChildLabel = labelLimited.querySelector('div') as HTMLElement | null;
        // console.log('checkExitChildLabel', checkExitChildLabel, limitDetect);
        if (checkExitChildLabel != null) {
          // console.log('có tồn lại lable rồi eidt nó thôi');
          checkExitChildLabel.innerHTML = t('RangeDate.Limit') + ': ' + limitDetect + ' ' + t('RangeDate.Days');
        } else {
          const div = document.createElement('div');
          div.className = 'content-limit';
          div.innerHTML = t('RangeDate.Limit') + ': ' + limitDetect + ' ' + t('RangeDate.Days');
          labelLimited.appendChild(div);
        }
      }
    }

    // console.log('reset date');
    if (props.limitTimeRange) {
      if (props.checkType === 'tongquan') {
        props.onSelectDateChange(
          [
            moment(preSelectDate7.beginTime).format('HH:mm MM/DD/YYYY'),
            moment(preSelectDate7.endTime).format('HH:mm MM/DD/YYYY')
          ],
          []
        );
        refTime.current.setStartDate(moment(preSelectDate7.beginTime));
        refTime.current.setEndDate(moment(preSelectDate7.endTime));
      } else {
        props.onSelectDateChange(
          [moment().startOf('day').format('HH:mm MM/DD/YYYY'), moment().endOf('day').format('HH:mm MM/DD/YYYY')],
          []
        );
        refTime.current.setStartDate(moment().startOf('day'));
        refTime.current.setEndDate(moment().endOf('day'));
      }
    }
  }, [props.limitTimeRange]);

  useEffect(() => {
    if (resetTime) {
      if (props.limitTimeRange) {
        if (props.checkType === 'tongquan' || props.checkType === 'vikythuat') {
          props.onSelectDateChange(
            [
              moment(preSelectDate7.beginTime).format('HH:mm MM/DD/YYYY'),
              moment(preSelectDate7.endTime).format('HH:mm MM/DD/YYYY')
            ],
            []
          );
          refTime.current.setStartDate(moment(preSelectDate7.beginTime));
          refTime.current.setEndDate(moment(preSelectDate7.endTime));
        } else {
          props.onSelectDateChange(
            [moment().startOf('day').format('HH:mm MM/DD/YYYY'), moment().endOf('day').format('HH:mm MM/DD/YYYY')],
            []
          );
          refTime.current.setStartDate(moment().startOf('day'));
          refTime.current.setEndDate(moment().endOf('day'));
        }
      }
      setTimeout(() => {
        dispatch(updateResetDateTime(false));
      }, 200);
    }
  }, [dispatch, preSelectDate7.beginTime, preSelectDate7.endTime, props, resetTime]);

  return (
    <div
      className="flex flex-inline ffs-text"
      style={{
        opacity: props.disabled ? 0.6 : 1,
        cursor: props.disabled ? 'not-allowed' : 'default',
        pointerEvents: props.disabled ? 'none' : 'auto'
      }}
    >
      <RangePickerStyled
        {...props}
        rangeMin={timeLimit}
        ref={refTime}
        initialSettings={{
          startDate: dates?.[0],
          endDate: dates?.[1],
          timePicker24Hour: true,
          ranges: useRangeLang,
          timePicker: true,
          alwaysShowCalendars: true,
          autoApply: false,
          minDate: props.limitPrevDates
            ? moment().subtract(props.limitPrevDates, 'day').startOf('days').format('HH:mm DD/MM/YYYY')
            : undefined,
          maxDate: moment().endOf('days').format('HH:mm DD/MM/YYYY'),
          showCustomRangeLabel: false,
          isCustomDate: true,
          linkedCalendars: false,
          locale: {
            firstDay: 1,
            format: 'HH:mm DD/MM/YYYY',
            applyLabel: t('RangeDate.Apply'),
            cancelLabel: 'Huỷ',
            daysOfWeek: daysOfWeekLang,
            monthNames: monthNamesLang
          }
        }}
        onHide={() => setOpenTutorial(false)}
        // onEvent={() => console.log('event here')}
        // onClickDate={handleClickDate}
        onCallback={handleCallback}
      >
        <input
          disabled={props.disabled}
          style={{
            maxWidth: '285px',
            minWidth: '265px',
            width: props.widthBox ? `${props.widthBox}px !important` : '100%',
            fontFamily: 'Roboto'
          }}
          type="text"
          className={classNames(
            'range_pickerjs form-control cursor-pointer bg-white appearance-none border border-gray-300 rounded-[4px] w-full py-[0.4rem] max-h-[35px] pl-8 text-gray-700 leading-tight focus:outline-none focus:bg-white hover:border-gray-400 focus:shadow-[rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 2px; !important] focus:border-blue-600 text-[13px]'
          )}
        ></input>
      </RangePickerStyled>
      <div
        style={{
          fontFamily: 'Roboto',
          opacity: props.disabled ? 0.5 : 1,
          cursor: props.disabled ? 'not-allowed' : 'pointer',
          pointerEvents: props.disabled ? 'none' : 'auto'
        }}
        className="absolute items-center translate-y-[7px] translate-x-[11px] cursor-pointer"
        onClick={() => handleClickIcon()}
      >
        <IoCalendarOutline size={14} />
      </div>
    </div>
  );
};

const RangePickerStyled: any = styled(DateRangePicker)<{
  isSelectTimeHour?: boolean;
  isRangeMin?: boolean;
  rangeMin?: number;
}>`
  &ul {
    background: aliceblue;
    color: #00fff;
  }
`;

export default RangeDateJs;
